(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fyra-back-to-top"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Аннотация 2: синхронна с навбаром — скролл вниз прячет, скролл вверх сразу показывает, порог 8 px;
       в самом верху страницы скрыта всегда. Свой scroll-listener, от навбара не зависит. */
    var THRESHOLD = 8;
    var reduceMotionMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    function reduceMotion() { return !!(reduceMotionMq && reduceMotionMq.matches); }

    function bind(btn) {
      if (btn.dataset.fyraBound) return;
      btn.dataset.fyraBound = '1';
      btn.removeAttribute('hidden');
      var topZone = parseInt(btn.dataset.topZone, 10);
      if (isNaN(topZone) || topZone < 0) topZone = THRESHOLD;
      var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var ticking = false;

      function update() {
        ticking = false;
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        var delta = y - lastY;
        if (y <= topZone) {
          btn.classList.remove('is-visible');
          lastY = y;
        } else if (Math.abs(delta) >= THRESHOLD) {
          btn.classList.toggle('is-visible', delta < 0);
          lastY = y;
        }
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }
      function onClick() {
        window.scrollTo({ top: 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
        btn.classList.remove('is-visible');
        var target = document.querySelector('#get-fyra, main, body');
        if (target && typeof target.focus === 'function') {
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      btn.addEventListener('click', onClick);
      update();

      if (inEditor) {
        document.addEventListener('shopify:section:unload', function (e) {
          if (e.target && e.target.contains(btn)) {
            window.removeEventListener('scroll', onScroll);
            btn.removeEventListener('click', onClick);
          }
        });
      }
    }

    function bindAll(root) {
      var nodes = (root || document).querySelectorAll('[data-fyra-back-to-top]');
      Array.prototype.forEach.call(nodes, bind);
    }

    bindAll(document);
    if (inEditor) {
      document.addEventListener('shopify:section:load', function (e) { if (e.target) bindAll(e.target); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyra-expect"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* 1920 / 1280 — What To Expect / Chart: 20 шагов. [x, y] — центр Head (Figma top-left + 9), rv — ширина Reveal; система 1440×340 */
    var STEPS = [
      [104, 295, 107], [138.9, 296, 142], [193.5, 294.4, 196], [280.4, 284.1, 283], [382, 262.5, 385],
      [464, 240, 467], [549.7, 217.7, 553], [610.3, 206.1, 613], [658.6, 198.6, 662], [729.1, 188.3, 732],
      [824, 171, 827], [888.1, 158, 891], [980.2, 141, 983], [1047, 129.4, 1050], [1108.7, 118.5, 1112],
      [1184, 104, 1187], [1246, 95.4, 1249], [1295.9, 93.5, 1299], [1353.7, 93.2, 1357], [1395.8, 91.6, 1399]
    ];
    var LAST = STEPS.length - 1;
    var WEEK_STEP = [0, 5, 10, 15];        // Week 1 → Step=01, Week 2 → 06, Week 6 → 11, Week 10+ → 16
    var BUBBLE_LEFT = [-72, -71, -66, -73]; // левый край выноски от центра Head по неделям (Figma)
    var STEP_MS = 1000;                     // Smart Animate 1000 linear
    var HOLD_MS = 10;                       // After delay 10 ms
    var LOOP_MS = 400;                      // Step=20 → Step=01: Dissolve 400 ease-out
    var JUMP_MS = 250;                      // кнопка недели: Dissolve 250 ease-out
    var TL_PAUSE = 2500, TL_MS = 600;       // 768 / 402: пауза 2500, Smart Animate 600 ease-in-out
    var EASE_OUT = 'cubic-bezier(0,0,.58,1)';

    /* FX / Pulse: диаметр и прозрачность кольца по 20 шагам; кольцо k сдвинуто на 4 шага */
    var PULSE_DESK = {
      d: [140, 269, 372, 467, 558, 645, 729, 812, 893, 972, 1050, 1127, 1202, 1277, 1351, 1424, 1497, 1568, 1640, 1710],
      o: [0, .18, .2, .19, .17, .16, .14, .13, .12, .11, .09, .08, .07, .06, .05, .04, .03, .02, .01, 0],
      sw: function (ph) { return 116 - 3 * ph; }                           // обводка тоньше по мере роста: 116 → 59
    };
    var PULSE_MOB = {
      d: [58.8, 108.2, 147.8, 184.4, 219.2, 252.7, 285.2, 316.9, 347.9, 378.4, 408.3, 437.8, 466.9, 495.6, 524, 552.1, 580, 607.5, 634.8, 661.9],
      o: [0, .16, .18, .17, .16, .14, .13, .12, .11, .1, .09, .07, .06, .05, .04, .03, .03, .02, .01, 0],
      sw: function (ph, k) { return [48.7, 43.7, 38.6, 33.6, 28.6][k]; }  // Mobile / FX / Pulse: у каждого кольца своя обводка
    };
    var RING_PAD = 150;                     // поле svg за краем секции (см. CSS)

    var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var chartMq = window.matchMedia('(min-width: 1024px)');
    var mobMq = window.matchMedia('(max-width: 767px)');

    function lerp(a, b, t) { return a + (b - a) * t; }

    function init(root) {
      if (root.dataset.fyraExpectReady) return;
      var chart = root.querySelector('.fyra-expect__chart');
      var weeksEl = root.querySelector('.fyra-expect__weeks');
      var cards = Array.prototype.slice.call(root.querySelectorAll('.fyra-expect__card'));
      if (!chart || !weeksEl || !cards.length) return;
      root.dataset.fyraExpectReady = '1';
      var steps = cards.map(function (c) { return c.closest('.fyra-expect__step'); });
      var dyn = chart.querySelector('.fyra-expect__dyn');
      var sticker = chart.querySelector('.fyra-expect__sticker');
      var bubble = chart.querySelector('.fyra-expect__bubble');
      var faces = Array.prototype.slice.call(chart.querySelectorAll('.fyra-expect__face'));
      var rings = root.querySelector('.fyra-expect__rings');
      var circles = rings ? Array.prototype.slice.call(rings.querySelectorAll('circle')) : [];
      var nWeeks = Math.min(cards.length, WEEK_STEP.length);

      var visible = false, focused = false, raf = null;
      var chartW = 1440, ringCx = 0, ringCy = 0;
      var faceW = [];

      /* ---------- состояние графика ---------- */
      var pos = 0;              // непрерывная позиция 0..19 (номер шага − 1 + доля перехода)
      var anchor = 0;           // шаг, на котором стоим / с которого уходим
      var trans = null;         // { from, to, t0, ms } — идущий Smart Animate
      var holdUntil = 0;        // конец паузы 10 мс
      var ghosts = [];
      var pulseT0 = null, pulseOff = 0;   // независимые часы пульсации (768 / 402)
      var tlStep = 0, tlTimer = null;
      var lastRings = 0;

      function weekOfStep(s) { var w = 0; for (var i = 0; i < nWeeks; i++) if (s >= WEEK_STEP[i]) w = i; return w; }

      function setWeekVars(ms, ease) {
        weeksEl.style.setProperty('--fyx-wd', ms + 'ms');
        weeksEl.style.setProperty('--fyx-we', ease);
      }
      function applyWeeks(active) {
        cards.forEach(function (card, i) {
          var on = i === active, past = i < active;
          card.classList.toggle('is-active', on);
          card.classList.toggle('is-past', past);
          if (steps[i]) { steps[i].classList.toggle('is-active', on); steps[i].classList.toggle('is-past', past); }
          if (chartMq.matches) card.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      function applyInert() {
        cards.forEach(function (card, i) { card.classList.toggle('is-inert', chartMq.matches && WEEK_STEP[i] === anchor); });
      }
      function measureFaces() {
        faceW = faces.map(function (f) { return f.offsetWidth ? Math.ceil(f.offsetWidth) + 36 : 0; });   // Bubble: поля 18 + 18
      }
      function applySticker(w) {
        faces.forEach(function (f, i) { f.classList.toggle('is-active', i === w); });
        var face = faces[w];
        if (sticker) sticker.classList.toggle('is-empty', !face || face.hasAttribute('data-empty'));
        if (bubble) {
          if (faceW[w]) bubble.style.setProperty('--bw', faceW[w] + 'px');
          bubble.style.setProperty('--bl', (BUBBLE_LEFT[w] != null ? BUBBLE_LEFT[w] : -72) + 'px');
        }
      }

      function paint(p) {
        var k = Math.min(LAST, Math.floor(p)), f = p - k;
        var a = STEPS[k], b = STEPS[Math.min(LAST, k + 1)];
        if (k >= LAST) f = 0;
        var s = chartW / 1440;
        dyn.style.setProperty('--hx', (lerp(a[0], b[0], f) * s).toFixed(2) + 'px');
        dyn.style.setProperty('--hy', lerp(a[1], b[1], f).toFixed(2) + 'px');
        dyn.style.setProperty('--rv', (100 - lerp(a[2], b[2], f) / 14.4).toFixed(4) + '%');
      }

      /* ---------- пульсация ---------- */
      function ringGeometry() {
        if (!rings) return;
        var w = root.offsetWidth, h = root.offsetHeight;
        if (chartMq.matches) { ringCx = w - 490; ringCy = 215; }            // 1920 / 1280: центр 490 от правого края, 215 сверху
        else if (!mobMq.matches) { ringCx = w / 2; ringCy = h / 2; }       // 768: по центру блока
        else { ringCx = w - 102; ringCy = 200; }                           // 402: 300 × 200 → 102 от правого края
        circles.forEach(function (c) { c.setAttribute('cx', (ringCx + RING_PAD).toFixed(1)); c.setAttribute('cy', (ringCy + RING_PAD).toFixed(1)); });
      }
      function paintRings(p) {
        var T = mobMq.matches ? PULSE_MOB : PULSE_DESK;
        circles.forEach(function (c, k) {
          var ph = ((p + 4 * k) % 20 + 20) % 20, i = Math.floor(ph), f = ph - i, j = (i + 1) % 20;
          var d = lerp(T.d[i], T.d[j], f), o = lerp(T.o[i], T.o[j], f), sw = lerp(T.sw(i, k), T.sw(j === 0 ? 20 : j, k), f);
          c.setAttribute('r', (d / 2).toFixed(1));
          c.setAttribute('stroke-width', sw.toFixed(1));
          c.setAttribute('opacity', o.toFixed(3));
        });
      }

      /* ---------- Dissolve: старый кадр гаснет, новый проявляется ---------- */
      function clearGhosts() {
        ghosts.forEach(function (g) { if (g.el.parentNode) g.el.parentNode.removeChild(g.el); window.clearTimeout(g.t); });
        ghosts = [];
        [dyn, rings].forEach(function (el) { if (el) { el.style.transition = ''; el.style.opacity = ''; } });
        if (dyn) dyn.classList.remove('is-instant');
      }
      function dissolveTo(step, ms) {
        clearGhosts();
        var olds = [dyn, rings].filter(Boolean).map(function (el) {
          var g = el.cloneNode(true);
          g.classList.add('is-ghost');
          g.setAttribute('aria-hidden', 'true');
          el.parentNode.insertBefore(g, el.nextSibling);
          return g;
        });
        dyn.classList.add('is-instant');
        setWeekVars(ms, EASE_OUT);
        pos = step; anchor = step; trans = null;
        var w = weekOfStep(step);
        applyWeeks(w); applySticker(w); applyInert();
        paint(pos); paintRings(pos);
        [dyn, rings].filter(Boolean).forEach(function (el) { el.style.transition = 'none'; el.style.opacity = '0'; });
        void root.offsetWidth;
        var tr = 'opacity ' + ms + 'ms ' + EASE_OUT;
        [dyn, rings].filter(Boolean).forEach(function (el) { el.style.transition = tr; el.style.opacity = '1'; });
        olds.forEach(function (g) {
          g.style.transition = tr; g.style.opacity = '0';
          var rec = { el: g, t: 0 };
          rec.t = window.setTimeout(function () { if (g.parentNode) g.parentNode.removeChild(g); }, ms + 60);
          ghosts.push(rec);
        });
        ghosts.push({ el: document.createElement('i'), t: window.setTimeout(function () {
          [dyn, rings].filter(Boolean).forEach(function (el) { el.style.transition = ''; el.style.opacity = ''; });
          dyn.classList.remove('is-instant');
        }, ms + 60) });
        holdUntil = performance.now() + ms + HOLD_MS;   // после Dissolve — 10 мс и дальше по шагам
      }

      /* ---------- шаг автопрокрутки ---------- */
      function startTransition(now) {
        if (anchor >= LAST) { dissolveTo(0, LOOP_MS); return; }                     // замыкание цикла — Dissolve 400
        trans = { from: anchor, to: anchor + 1, t0: now };
        var w = weekOfStep(anchor + 1);
        setWeekVars(STEP_MS, 'linear');
        dyn.style.setProperty('--fyx-sd', STEP_MS + 'ms');
        applyWeeks(w); applySticker(w);
      }

      function running() { return visible && !document.hidden && !focused && !reduceMq.matches; }

      function frame(now) {
        raf = null;
        if (!running()) return;
        if (chartMq.matches) {
          if (trans) {
            var k = Math.min(1, (now - trans.t0) / STEP_MS);
            pos = trans.from + k;
            paint(pos);
            if (k >= 1) { anchor = trans.to; pos = anchor; trans = null; holdUntil = now + HOLD_MS; applyInert(); }
          } else if (now >= holdUntil) {
            if (ghosts.length) clearGhosts();
            startTransition(now);
          }
          if (now - lastRings > 30) { paintRings(pos); lastRings = now; }
        } else {
          if (pulseT0 === null) pulseT0 = now - pulseOff;
          if (now - lastRings > 30) { paintRings(((now - pulseT0) / 1000) % 20); lastRings = now; }
        }
        raf = window.requestAnimationFrame(frame);
      }

      var pausedAt = null;
      function play() {
        if (!running()) { pause(); return; }
        if (pausedAt !== null) {
          var gap = performance.now() - pausedAt;
          if (trans) trans.t0 += gap;
          holdUntil += gap;
          pausedAt = null;
        }
        if (!raf) raf = window.requestAnimationFrame(frame);
        if (!chartMq.matches && !tlTimer) tlTimer = window.setTimeout(tlNext, TL_PAUSE);
      }
      function pause() {
        if (raf) { window.cancelAnimationFrame(raf); raf = null; }
        if (pausedAt === null) pausedAt = performance.now();
        if (pulseT0 !== null) { pulseOff = performance.now() - pulseT0; pulseT0 = null; }
        if (tlTimer) { window.clearTimeout(tlTimer); tlTimer = null; }
      }

      /* ---------- таймлайн 768 / 402 ---------- */
      function tlApply() {
        setWeekVars(TL_MS, 'var(--fyx-ease-io)');
        applyWeeks(tlStep);
      }
      function tlNext() {
        tlTimer = null;
        if (!running() || chartMq.matches) return;
        tlStep = (tlStep + 1) % nWeeks;
        tlApply();
        tlTimer = window.setTimeout(tlNext, TL_MS + TL_PAUSE);
      }

      /* ---------- режимы ---------- */
      function layout() {
        chartW = chart.offsetWidth || chartW;
        ringGeometry();
        if (chartMq.matches) {
          if (!faceW.length || !faceW[0]) measureFaces();
          dyn.style.setProperty('--fyx-sd', '0ms');
          paint(pos);
          applySticker(weekOfStep(trans ? trans.to : anchor));
          paintRings(pos);
        } else {
          paintRings(pulseT0 !== null ? ((performance.now() - pulseT0) / 1000) % 20 : pulseOff / 1000 % 20);
        }
      }
      function setMode() {
        pause(); pausedAt = null; trans = null; clearGhosts();
        cards.forEach(function (card) {
          if (chartMq.matches) { card.removeAttribute('tabindex'); }
          else { card.setAttribute('tabindex', '-1'); card.removeAttribute('aria-pressed'); }
        });
        setWeekVars(0, 'linear');
        if (chartMq.matches) {
          pos = reduceMq.matches ? LAST : anchor; if (reduceMq.matches) anchor = LAST;
          applyWeeks(weekOfStep(anchor)); applyInert();
        } else {
          tlStep = 0; applyWeeks(0); applyInert();
        }
        layout();
        holdUntil = performance.now() + HOLD_MS;
        play();
      }

      cards.forEach(function (card, i) {
        card.addEventListener('click', function () {
          if (!chartMq.matches || i >= nWeeks) return;          // 768 / 402: только автопрокрутка
          var target = WEEK_STEP[i];
          if (anchor === target) return;                         // кнопка своей недели на своём шаге неактивна
          if (reduceMq.matches) {
            pos = anchor = target; trans = null;
            var w = weekOfStep(target);
            setWeekVars(0, 'linear'); applyWeeks(w); applySticker(w); applyInert(); paint(pos); paintRings(pos);
            return;
          }
          dissolveTo(target, JUMP_MS);                           // Dissolve 250 ease-out; автопрокрутка идёт дальше с этого шага
          play();
        });
      });

      /* пауза только на фокусе с клавиатуры (наведение прототип не останавливает) */
      weeksEl.addEventListener('focusin', function (e) {
        if (e.target && e.target.matches && e.target.matches(':focus-visible')) { focused = true; pause(); }
      });
      weeksEl.addEventListener('focusout', function (e) {
        if (e.relatedTarget && weeksEl.contains(e.relatedTarget)) return;
        if (focused) { focused = false; play(); }
      });
      function onVisibility() { if (document.hidden) pause(); else play(); }
      document.addEventListener('visibilitychange', onVisibility);
      var onResize = function () { layout(); };
      window.addEventListener('resize', onResize);
      [chartMq, mobMq, reduceMq].forEach(function (mq) { if (mq.addEventListener) mq.addEventListener('change', setMode); else if (mq.addListener) mq.addListener(setMode); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { faceW = []; layout(); });

      var observer = null;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { visible = entry.isIntersecting; if (visible) play(); else pause(); });
        }, { threshold: 0 });
        observer.observe(root);
      } else {
        visible = true;
      }
      setMode();

      root._fyraExpectDestroy = function () {
        pause(); clearGhosts();
        if (observer) observer.disconnect();
        document.removeEventListener('visibilitychange', onVisibility);
        window.removeEventListener('resize', onResize);
        [chartMq, mobMq, reduceMq].forEach(function (mq) { if (mq.removeEventListener) mq.removeEventListener('change', setMode); else if (mq.removeListener) mq.removeListener(setMode); });
        delete root.dataset.fyraExpectReady;
      };
    }

    function initAll(scope) { (scope || document).querySelectorAll('.fyra-expect').forEach(init); }
    function destroyAll(scope) {
      (scope || document).querySelectorAll('.fyra-expect').forEach(function (root) { if (root._fyraExpectDestroy) root._fyraExpectDestroy(); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyra-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 250; /* FAQ / Accordion: 250 мс ease-in-out */
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var registry = [];

    function initSection(section) {
      if (!section || section.classList.contains('is-js')) return;
      var state = { section: section, timers: [] };
      registry.push(state);

      section.querySelectorAll('.fyra-faq__row').forEach(function (row) {
        var summary = row.querySelector('.fyra-faq__question');
        var body = row.querySelector('.fyra-faq__body');
        if (!summary) return;
        if (row.open) row.classList.add('is-open');
        if (!body) return; /* вопрос без ответа — нечего раскрывать */

        var closeTimer = null;

        function finishClose() {
          if (closeTimer) { clearTimeout(closeTimer); state.timers.splice(state.timers.indexOf(closeTimer), 1); closeTimer = null; }
          body.removeEventListener('transitionend', onEnd);
          row.open = false;
          row.classList.remove('is-closing');
        }
        function onEnd(e) {
          if (e.target === body && e.propertyName === 'grid-template-rows') finishClose();
        }

        summary.addEventListener('click', function (e) {
          e.preventDefault();

          if (reduced.matches) { /* без анимации: мгновенно */
            if (closeTimer) finishClose();
            row.open = !row.open;
            row.classList.toggle('is-open', row.open);
            return;
          }

          if (row.open && !row.classList.contains('is-closing')) {
            /* закрытие: 1fr → 0fr, [open] снимаем после перехода */
            row.classList.remove('is-open');
            row.classList.add('is-closing');
            body.addEventListener('transitionend', onEnd);
            closeTimer = setTimeout(finishClose, DURATION + 50);
            state.timers.push(closeTimer);
          } else {
            /* открытие (или повторный клик во время закрытия): [open] сразу, класс — на следующем кадре */
            if (closeTimer) { clearTimeout(closeTimer); state.timers.splice(state.timers.indexOf(closeTimer), 1); closeTimer = null; }
            body.removeEventListener('transitionend', onEnd);
            row.classList.remove('is-closing');
            row.open = true;
            requestAnimationFrame(function () {
              requestAnimationFrame(function () { row.classList.add('is-open'); });
            });
          }
        });
      });

      section.classList.add('is-js');
    }

    function initAll(root) {
      (root || document).querySelectorAll('.fyra-faq').forEach(initSection);
    }

    function destroy(root) {
      registry = registry.filter(function (state) {
        if (root && !root.contains(state.section)) return true;
        state.timers.forEach(clearTimeout);
        state.timers.length = 0;
        return false;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var row = e.target && e.target.closest ? e.target.closest('.fyra-faq__row') : null;
      if (row && !row.open) row.querySelector('.fyra-faq__question').click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyra-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reducedMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };
    var swipeMq = window.matchMedia ? window.matchMedia('(max-width: 1023px)') : { matches: false };   /* свайп галереи — планшет и мобиль (07.10) */

    /* <details> с анимацией высоты: тело — grid 1fr, на время сворачивания details остаётся open с классом is-closing (0fr),
       по таймеру ms снимаем open. Раскрытие: open + is-opening (0fr) → reflow → снять класс (1fr). При reduced-motion — мгновенно. */
    function animateDetails(details, body, ms, cleanups, guard) {
      var summary = details.querySelector('summary');
      if (!summary || !body) return;
      var timer = null;
      var settle = function () {
        if (timer) { clearTimeout(timer); timer = null; }
        details.classList.remove('is-opening', 'is-closing');
      };
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (guard && !guard()) { details.open = true; return; }
        if (reducedMq.matches) { settle(); details.open = !details.open; return; }
        var wasClosing = details.classList.contains('is-closing');
        settle();
        if (details.open && !wasClosing) {
          details.classList.add('is-closing');
          timer = setTimeout(function () { timer = null; details.open = false; details.classList.remove('is-closing'); }, ms);
        } else {
          details.classList.add('is-opening');
          details.open = true;
          void body.offsetHeight;
          details.classList.remove('is-opening');
        }
      });
      cleanups.push(settle);
      return settle;
    }

    function initHero(root) {
      if (!root || root.dataset.fyraHeroReady) return;
      root.dataset.fyraHeroReady = '1';
      var cleanups = [];
      root.fyraHeroCleanup = function () { cleanups.forEach(function (fn) { try { fn(); } catch (err) { /* noop */ } }); cleanups = []; };

      /* Gallery — Figma «Hero / Gallery»: превью — скользящее окно из 4 кадров,
         которое никогда не включает первый: start = clamp(i − 3, 1, N − 4).
         На первом слайде обводки нет; лейбла Clinicians' Choice живёт только на первом кадре.
         Тайминги: стрелка/превью 200ms ease-out, свайп на мобильном 250ms ease-out (data-motion="swipe" на галерее). */
      var gallery = root.querySelector('[data-gallery]');
      var ribbon = root.querySelector('[data-ribbon]');
      if (gallery) {
        var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
        var WINDOW = 4;
        var current = 0;
        var windowStart = function (i) {
          var total = thumbs.length;
          if (total <= WINDOW) return 0;
          return Math.min(Math.max(i - 3, 1), total - WINDOW);
        };
        var show = function (i, motion) {
          if (!slides.length) return;
          if (motion === 'swipe') gallery.setAttribute('data-motion', 'swipe'); else gallery.removeAttribute('data-motion');
          current = (i + slides.length) % slides.length;
          var start = windowStart(current);
          slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
          thumbs.forEach(function (t, idx) {
            var inWindow = idx >= start && idx < start + WINDOW;
            if (inWindow) t.removeAttribute('hidden'); else t.setAttribute('hidden', '');
            t.classList.toggle('is-active', idx === current);
            t.setAttribute('aria-pressed', idx === current ? 'true' : 'false');
          });
          if (ribbon) ribbon.classList.toggle('is-hidden', current !== 0 || ribbon.dataset.closed === '1');
        };
        var prev = gallery.querySelector('[data-prev]');
        var next = gallery.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', function () { show(current - 1); });
        if (next) next.addEventListener('click', function () { show(current + 1); });
        thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { if (idx !== current) show(idx); }); });   // активная миниатюра на клик не реагирует

        /* Свайп по картинке — планшет и мобиль, стрелки к нему в добавку (07.10; Mobile / Hero / Gallery, ON_DRAG): pointer events, порог 40px,
           горизонталь должна превышать вертикаль (touch-action: pan-y отдаёт вертикальный скролл браузеру). */
        var stage = gallery.querySelector('[data-stage]');
        if (stage && window.PointerEvent) {
          var THRESHOLD = 40;
          var sx = null, sy = null, pid = null, swiping = false;
          var reset = function () { sx = sy = null; pid = null; swiping = false; };
          stage.addEventListener('pointerdown', function (e) {
            if (!swipeMq.matches || slides.length < 2) return;
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            if (e.target && e.target.closest && e.target.closest('[data-ribbon-close]')) return;
            sx = e.clientX; sy = e.clientY; pid = e.pointerId; swiping = false;
          });
          stage.addEventListener('pointermove', function (e) {
            if (sx === null || e.pointerId !== pid) return;
            var dx = e.clientX - sx, dy = e.clientY - sy;
            if (!swiping && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
              swiping = true;
              try { stage.setPointerCapture(pid); } catch (err) { /* noop */ }
            }
          });
          stage.addEventListener('pointerup', function (e) {
            if (sx === null || e.pointerId !== pid) return;
            var dx = e.clientX - sx;
            if (swiping && Math.abs(dx) >= THRESHOLD) show(dx < 0 ? current + 1 : current - 1, 'swipe');
            reset();
          });
          stage.addEventListener('pointercancel', reset);
        }
        show(0);
      }

      /* Ribbon close — Clinicians' Choice / Label, Shown=True → False (250ms ease-out в CSS, desktop и mobile) */
      var ribbonClose = root.querySelector('[data-ribbon-close]');
      if (ribbon && ribbonClose) {
        ribbonClose.addEventListener('click', function (e) {
          e.stopPropagation();
          ribbon.dataset.closed = '1';
          ribbon.classList.add('is-hidden');
        });
      }

      /* Plan selection (fallback for browsers without :has). Тайминги в CSS: 250ms ease-out, mobile 350ms ease-in-out */
      var plans = Array.prototype.slice.call(root.querySelectorAll('[data-plan]'));
      var inputs = plans.map(function (p) { return p.querySelector('.fyra-hero__plan-input'); });
      var buyOnce = root.querySelector('.fyra-hero__buy-once');
      var deselectTimers = [];
      var sync = function () {
        plans.forEach(function (p, i) {
          var input = inputs[i];
          var selected = !!(input && input.checked);
          /* снятая карточка держит is-deselecting 250ms: иначе transition берёт 120ms ховера, и две карточки анимируются с разной длительностью */
          if (!selected && p.classList.contains('is-selected')) {
            p.classList.add('is-deselecting');
            if (deselectTimers[i]) clearTimeout(deselectTimers[i]);
            deselectTimers[i] = setTimeout(function () { p.classList.remove('is-deselecting'); deselectTimers[i] = null; }, 250);
          } else if (selected && p.classList.contains('is-deselecting')) {
            p.classList.remove('is-deselecting');
            if (deselectTimers[i]) { clearTimeout(deselectTimers[i]); deselectTimers[i] = null; }
          }
          p.classList.toggle('is-selected', selected);
          /* «Buy Once for $… (N Boxes)» меняется вместе с тарифом — Hero / Plan selector, Plan=3/2/1 */
          if (selected && buyOnce && p.dataset.buyOnce) buyOnce.textContent = p.dataset.buyOnce;
        });
      };
      if (inputs.length && !inputs.some(function (i) { return i && i.checked; })) {
        var first = inputs.find(function (i) { return i && !i.disabled; });
        if (first) first.checked = true;
      }
      inputs.forEach(function (input) { if (input) input.addEventListener('change', sync); });
      cleanups.push(function () { deselectTimers.forEach(function (t) { if (t) clearTimeout(t); }); deselectTimers = []; });
      sync();

      /* Product accordion — Hero / Product accordion: 250ms ease-in-out */
      Array.prototype.forEach.call(root.querySelectorAll('[data-acc]'), function (row) {
        animateDetails(row, row.querySelector('[data-acc-body]'), 250, cleanups);
      });

      /* Loved by Thousands — CSS-marquee; пауза при скрытой вкладке (hover/focus — в CSS) */
      var marquee = root.querySelector('[data-marquee]');
      if (marquee) {
        var onVisibility = function () { marquee.classList.toggle('is-paused', !!document.hidden); };
        /* Длительность круга под скорость прототипа: десктоп 58 px/с (580 px / 10 с), мобиль ≈48.6 px/с (680 px / 14 с) */
        var track = marquee.querySelector('.fyra-hero__track'), strip = marquee.querySelector('.fyra-hero__strip');
        var setSpeed = function () {
          if (!track || !strip) return;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var period = strip.getBoundingClientRect().width + gap;
          var speed = mobileMq.matches ? 680 / 14 : 580 / 10;
          if (period > 0) track.style.setProperty('--loved-dur', (period / speed).toFixed(2) + 's');
        };
        setSpeed();
        window.addEventListener('resize', setSpeed);
        cleanups.push(function () { window.removeEventListener('resize', setSpeed); });
        document.addEventListener('visibilitychange', onVisibility);
        cleanups.push(function () { document.removeEventListener('visibilitychange', onVisibility); });
        onVisibility();
      }
    }

    /* Direct checkout — «Add to Cart» ведёт сразу в чекаут через cart permalink:
       /cart/{variant_id}:1 очищает корзину и кладёт ровно выбранный вариант, повторный клик не удваивает.
       UTM из адреса лендинга уезжают в атрибуты заказа — для атрибуции по креативу. Без JS работает return_to=/checkout. */
    function initDirectCheckout(root) {
      if (root.dataset.checkout === 'cart') return;
      var form = root.querySelector('form.fyra-hero__form');
      if (!form) return;
      var attrs = function () {
        var out = [], q = new URLSearchParams(location.search);
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ref'].forEach(function (k) {
          var v = q.get(k); if (v) out.push('attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(v));
        });
        out.push('attributes[' + encodeURIComponent('landing') + ']=' + encodeURIComponent(location.pathname));
        return out.join('&');
      };
      var permalink = function () {
        var checked = form.querySelector('input[name="id"]:checked') || root.querySelector('input[name="id"]:checked');
        if (!checked || !checked.value) return null;
        var qty = form.querySelector('input[name="quantity"]');
        return '/cart/' + checked.value + ':' + (qty && qty.value ? qty.value : 1) + '?' + attrs();
      };
      form.addEventListener('submit', function (e) {
        var url = permalink();
        if (!url) return; /* нет варианта — пусть отработает нативный сабмит */
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]') || root.querySelector('.fyra-hero__btn');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn.dataset.busy = '1'; }
        location.assign(url);
      });
      /* «Назад» из чекаута: браузер достаёт страницу из bfcache как была — с выключенной кнопкой. Возвращаем её в строй */
      window.addEventListener('pageshow', function () {
        root.querySelectorAll('[data-busy]').forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); b.removeAttribute('data-busy'); });
      });
      var buyOnce = root.querySelector('.fyra-hero__buy-once');
      if (buyOnce && (buyOnce.getAttribute('href') || '#') .charAt(0) === '#') {
        buyOnce.addEventListener('click', function (e) { var url = permalink(); if (url) { e.preventDefault(); location.assign(url); } });
      }
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-fyra-hero]'), function (r) { initHero(r); initDirectCheckout(r); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-fyra-hero]') : null;
      if (root) { delete root.dataset.fyraHeroReady; initHero(root); initDirectCheckout(root); }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-fyra-hero]') : null;
      if (root && root.fyraHeroCleanup) { root.fyraHeroCleanup(); delete root.dataset.fyraHeroReady; }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyra-navbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-fyra-navbar]');
    if (!root || root.dataset.fyraNavbarReady === '1') return;
    root.dataset.fyraNavbarReady = '1';

    var chrome = root.querySelector('[data-fyra-navbar-chrome]');
    var burger = root.querySelector('[data-fyra-navbar-burger]');
    var menu = root.querySelector('[data-fyra-navbar-menu]');
    var links = Array.prototype.slice.call(root.querySelectorAll('.fyra-navbar__link'));
    var threshold = parseInt(root.dataset.threshold, 10) || 8;
    var STUCK_AT = parseInt(root.dataset.stuckAt, 10) || 40; /* designer app.js: is-stuck when scrollY > 40 */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null; /* mobile timings (Buy now 500ms scroll) */
    var isMobile = function () { return !!(mobileMq && mobileMq.matches); };
    var burgerMq = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null; /* burger + menu live up to 1023 (CSS) */

    /* ---------- hide on scroll down / show on scroll up ---------- */
    var lastY = window.pageYOffset || 0;
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.pageYOffset || 0;
        var delta = y - lastY;
        chrome.classList.toggle('is-stuck', y > STUCK_AT);
        if (y <= 0) {
          chrome.classList.remove('is-hidden');
          lastY = 0;
        } else if (Math.abs(delta) >= threshold) {
          if (delta > 0 && !isMenuOpen()) {
            chrome.classList.add('is-hidden');
          } else if (delta < 0) {
            chrome.classList.remove('is-hidden');
          }
          lastY = y;
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---------- smooth anchor scroll: 0.6s ease-in-out (desktop, annotation 1);
       mobile Buy now: SCROLL_ANIMATE 500ms ease-out (Mobile / Navbar) ---------- */
    var DURATION = 600;
    var BUY_DURATION_MOBILE = 500;
    function easeInOut(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

    function scrollToTarget(target, duration, ease) {
      duration = duration || DURATION;
      ease = ease || easeInOut;
      var startY = window.pageYOffset || 0;
      var rect = target.getBoundingClientRect();
      var offset = 0;
      if (rect.top < 0) offset = chrome.offsetHeight; /* scrolling up: nav stays visible, keep it clear of the target */
      var endY = Math.max(0, startY + rect.top - offset);
      if (reduceMotion) { window.scrollTo(0, endY); return; }
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        window.scrollTo(0, startY + (endY - startY) * ease(p));
        if (p < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }

    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-fyra-anchor]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      closeMenu();
      if (a.classList.contains('fyra-navbar__buy') && isMobile()) {
        scrollToTarget(target, BUY_DURATION_MOBILE, easeOut);
      } else {
        scrollToTarget(target);
      }
      if (history.replaceState) history.replaceState(null, '', href);
    });

    /* Якоря в теле страницы (кнопки → Buy box, «367+ VERIFIED REVIEWS» → 08 Real Results):
       плавно, 700 ms ease-in-out (FYRA-FIGMA-SPEC §4 «Кнопки»); ссылки навбара обрабатываются выше */
    var PAGE_DURATION = 700;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || root.contains(a)) return;
      var href = a.getAttribute('href') || '';
      if (href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      scrollToTarget(target, PAGE_DURATION, easeInOut);
      if (history.replaceState) history.replaceState(null, '', href);
    });

    /* ---------- active link (scroll spy) ---------- */
    function setActive(id) {
      links.forEach(function (l) {
        var on = l.getAttribute('href') === '#' + id;
        l.classList.toggle('is-active', on);
        if (on) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current');
      });
    }
    var io = null;
    if ('IntersectionObserver' in window && links.length) {
      var targets = links.map(function (l) {
        var h = l.getAttribute('href') || '';
        return h.charAt(0) === '#' ? document.getElementById(h.slice(1)) : null;
      }).filter(Boolean);
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) setActive(en.target.id); });
      }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });
      targets.forEach(function (t) { io.observe(t); });
    }

    /* ---------- mobile menu ---------- */
    var MENU_MS = 250; /* Mobile / Navbar Closed <-> Open, 250ms ease-out */
    var menuTimer = null;
    function isMenuOpen() { return !!(menu && menu.classList.contains('is-open')); }
    function openMenu() {
      if (!menu || !burger) return;
      if (menuTimer) { clearTimeout(menuTimer); menuTimer = null; }
      menu.hidden = false;
      void menu.offsetHeight; /* commit display:block before the transition starts */
      menu.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      burger.setAttribute('aria-label', 'Close menu');
      chrome.classList.remove('is-hidden');
    }
    function closeMenu() {
      if (!menu || !burger) return;
      if (!isMenuOpen()) { menu.hidden = true; return; }
      menu.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
      if (menuTimer) clearTimeout(menuTimer);
      if (reduceMotion) { menu.hidden = true; menuTimer = null; return; }
      menuTimer = setTimeout(function () { menu.hidden = true; menuTimer = null; }, MENU_MS);
    }
    function onDocKeydown(e) { if (e.key === 'Escape' && isMenuOpen()) { closeMenu(); burger.focus(); } }
    function onDocClick(e) { if (isMenuOpen() && !root.contains(e.target)) closeMenu(); }
    function onBurgerMq(mq) { if (mq.matches) closeMenu(); }
    if (burger) {
      burger.addEventListener('click', function () { isMenuOpen() ? closeMenu() : openMenu(); });
      document.addEventListener('keydown', onDocKeydown);
      document.addEventListener('click', onDocClick);
      if (burgerMq) {
        if (burgerMq.addEventListener) burgerMq.addEventListener('change', onBurgerMq);
        else if (burgerMq.addListener) burgerMq.addListener(onBurgerMq);
      }
    }

    if (inEditor) {
      var onUnload = function (e) {
        if (!(e.target && e.target.contains(root))) return;
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('keydown', onDocKeydown);
        document.removeEventListener('click', onDocClick);
        if (burgerMq) {
          if (burgerMq.removeEventListener) burgerMq.removeEventListener('change', onBurgerMq);
          else if (burgerMq.removeListener) burgerMq.removeListener(onBurgerMq);
        }
        if (io) { io.disconnect(); io = null; }
        if (menuTimer) { clearTimeout(menuTimer); menuTimer = null; }
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyra-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Reviews / Carousel (Figma-прототип):
       автопрокрутка — пауза 4 с (десктоп и мобильный), переход в CSS (550 / 500 мс ease-in-out);
       мобильный — свайп pointer-events, остановка по центру карточки (шаг 16 − 334·i). */
    var AUTOPLAY_MS = 4000;
    var SWIPE_THRESHOLD = 40;   // px по горизонтали, чтобы свайп засчитался
    var DRAG_START = 6;         // px, после которых жест считается горизонтальным
    var MOBILE = window.matchMedia('(max-width: 1023px)');   // мобильная карусель на 768 и 402
    var PHONE = window.matchMedia('(max-width: 767px)');     // 402: активная карточка по центру
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(root) {
      if (!root || root.dataset.fyraReviewsReady) return;
      root.dataset.fyraReviewsReady = '1';
      var viewport = root.querySelector('.fyra-reviews__viewport');
      /* Карточки за краем ленты (overflow hidden) ленивая загрузка не видит — фото въезжали пустыми.
         Когда лента в 800 px от экрана, грузим все её картинки сразу. */
      if (viewport && 'IntersectionObserver' in window) {
        var preload = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          viewport.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
          preload.disconnect();
        }, { rootMargin: '800px 0px' });
        preload.observe(viewport);
      }
      var track = root.querySelector('[data-fyra-reviews-track]');
      var cards = track ? Array.prototype.slice.call(track.querySelectorAll('[data-fyra-reviews-card]')) : [];
      var prev = root.querySelector('[data-fyra-reviews-prev]');
      var next = root.querySelector('[data-fyra-reviews-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fyra-reviews-dot]'));
      if (!viewport || !track || !cards.length) return;

      var index = 0;
      var timer = null;
      var hovered = false;
      var focused = false;
      var dragging = false;
      var swiped = false;

      /* Самый левый допустимый сдвиг трека (десктоп: правый край ленты не уходит от правого поля). */
      function minShift() { return Math.min(0, viewport.clientWidth - track.scrollWidth); }

      /* Сдвиг трека для карточки i.
         Мобильный: карточка по центру вьюпорта — x = (W − w)/2 − left_i;
                    при 402 / 322 / gap 12 это ровно 16 − 334·i в координатах контейнера.
         Десктоп:   карточка i встаёт на место первой — x = left_0 − left_i. */
      function offsetFor(i) {
        var card = cards[i];
        var anchor = PHONE.matches ? (viewport.clientWidth - card.offsetWidth) / 2 : cards[0].offsetLeft;   // 768: лента от левого поля, как в Figma
        return anchor - card.offsetLeft;
      }
      function maxIndex() {
        if (MOBILE.matches) return cards.length - 1;
        var limit = minShift();
        for (var i = 0; i < cards.length; i++) if (offsetFor(i) <= limit) return i;
        return cards.length - 1;
      }
      function apply(x) { track.style.setProperty('--fyra-reviews-x', Math.round(x * 100) / 100 + 'px'); }
      function sync(last) {
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= last;
        dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === index ? 'true' : 'false'); });
      }
      function goTo(i) {
        var last = maxIndex();
        index = Math.max(0, Math.min(last, i));
        var x = offsetFor(index);
        if (!MOBILE.matches) x = Math.max(x, minShift());
        apply(x);
        sync(last);
      }

      /* Автопрокрутка: setInterval с паузой 4 с; стоит на hover / фокусе / скрытой вкладке / reduced-motion / во время свайпа. */
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function start() {
        stop();
        if (REDUCED.matches || document.hidden || hovered || focused || dragging || cards.length < 2) return;
        timer = window.setInterval(function () { goTo(index >= maxIndex() ? 0 : index + 1); }, AUTOPLAY_MS);
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); start(); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); start(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-fyra-reviews-dot'), 10) || 0); start(); });
      });

      /* Как в прототипе: лента листается каждые 4 с и под курсором (паузы на hover нет — иначе секция на весь экран почти всегда стоит);
         пауза только на фокусе с клавиатуры, во время перетаскивания и на скрытой вкладке. */
      root.addEventListener('focusin', function (e) {
        if (!(e.target && e.target.matches && e.target.matches(':focus-visible'))) return;   // клик мышью по стрелке не останавливает автолистание
        focused = true; stop();
        var card = e.target && e.target.closest ? e.target.closest('[data-fyra-reviews-card]') : null;
        if (card) { viewport.scrollLeft = 0; goTo(cards.indexOf(card)); }
      });
      root.addEventListener('focusout', function (e) {
        if (root.contains(e.relatedTarget)) return;
        focused = false; start();
      });

      /* Свайп на мобильном: pointerdown / move / up, порог 40 px, остановка по центру. */
      var pointerId = null, startX = 0, startY = 0, baseX = 0, dx = 0, horizontal = false;
      function endDrag() {
        if (pointerId === null) return;
        var wasDragging = dragging;
        if (viewport.hasPointerCapture && viewport.hasPointerCapture(pointerId)) viewport.releasePointerCapture(pointerId);
        pointerId = null; dragging = false; horizontal = false;
        track.classList.remove('is-dragging');
        if (wasDragging) {
          swiped = true;
          if (dx <= -SWIPE_THRESHOLD) goTo(index + 1);
          else if (dx >= SWIPE_THRESHOLD) goTo(index - 1);
          else goTo(index);
        }
        start();
      }
      /* Перетаскивание работает и на десктопе (мышь / тачпад), не только на мобильном. */
      viewport.addEventListener('pointerdown', function (e) {
        if (pointerId !== null) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        pointerId = e.pointerId; startX = e.clientX; startY = e.clientY; dx = 0; horizontal = false; swiped = false;
        baseX = offsetFor(index);
      });
      viewport.addEventListener('pointermove', function (e) {
        if (e.pointerId !== pointerId) return;
        dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!horizontal) {
          if (Math.abs(dx) < DRAG_START && Math.abs(dy) < DRAG_START) return;
          if (Math.abs(dy) > Math.abs(dx)) { pointerId = null; return; }   // вертикальный скролл страницы
          horizontal = true; dragging = true; stop();
          track.classList.add('is-dragging');
          if (viewport.setPointerCapture) viewport.setPointerCapture(pointerId);
        }
        var over = (index === 0 && dx > 0) || (index === cards.length - 1 && dx < 0);
        apply(baseX + (over ? dx * 0.35 : dx));
      });
      viewport.addEventListener('pointerup', function (e) { if (e.pointerId === pointerId) endDrag(); });
      viewport.addEventListener('pointercancel', function (e) { if (e.pointerId === pointerId) endDrag(); });
      viewport.addEventListener('lostpointercapture', function (e) { if (e.pointerId === pointerId) endDrag(); });
      track.addEventListener('click', function (e) {
        if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; }
      }, true);

      /* Горизонтальный скролл колесом / тачпадом: копим deltaX, шагаем на карточку раз в 500 мс (пока идёт переход). */
      var wheelAcc = 0, wheelLock = 0;
      viewport.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   // вертикаль — обычный скролл страницы
        e.preventDefault();
        var now = Date.now();
        if (now < wheelLock) return;
        wheelAcc += e.deltaX;
        if (Math.abs(wheelAcc) < 40) return;
        stop();
        goTo(index + (wheelAcc > 0 ? 1 : -1));
        wheelAcc = 0; wheelLock = now + 500;
        start();
      }, { passive: false });

      function onResize() { goTo(index); }
      function onVisibility() { if (document.hidden) stop(); else start(); }
      function onMotion() { start(); }
      window.addEventListener('resize', onResize);
      document.addEventListener('visibilitychange', onVisibility);
      if (MOBILE.addEventListener) MOBILE.addEventListener('change', onResize);
      if (REDUCED.addEventListener) REDUCED.addEventListener('change', onMotion);

      function destroy() {
        stop();
        window.removeEventListener('resize', onResize);
        document.removeEventListener('visibilitychange', onVisibility);
        if (MOBILE.removeEventListener) MOBILE.removeEventListener('change', onResize);
        if (REDUCED.removeEventListener) REDUCED.removeEventListener('change', onMotion);
        document.removeEventListener('shopify:section:unload', onUnload);
      }
      function onUnload(e) { if (e.target && e.target.contains(root)) destroy(); }
      document.addEventListener('shopify:section:unload', onUnload);

      goTo(0);
      start();
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-fyra-reviews]'), init);
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) Array.prototype.forEach.call(e.target.querySelectorAll('[data-fyra-reviews]'), init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyra-systems"] && !Shopify.designMode) return;
  try {
    
  /* Three Systems — Swipe (768 / 402, FYRA-FIGMA-SPEC §5): автосмена — пауза 3500 мс, переход 500 мс;
     свайп / перетаскивание — 500 мс ease-in-out; активная карточка по центру, шаг 664 (768) / 356 (402).
     1280: карточки колонкой, фото 338×338 — чистый CSS. */
  class FyraSystemsCards extends HTMLElement {
    static get AUTOPLAY_MS() { return 3500; }
    static get SWIPE_MS() { return 500; }
    static get SWIPE_THRESHOLD() { return 40; }

    connectedCallback() {
      this.track = this.querySelector('.fyra-systems__cards');
      /* карточки за краем ленты ленивая загрузка не видит — грузим картинки ленты, когда она в 800 px от экрана */
      if (this.track && 'IntersectionObserver' in window) {
        const preload = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.track.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
          preload.disconnect();
        }, { rootMargin: '800px 0px' });
        preload.observe(this);
      }
      this.dots = Array.from(this.querySelectorAll('.fyra-systems__dot'));
      if (!this.track || !this.dots.length) return;
      this.cards = Array.from(this.track.children);
      this.index = 0;
      this.timer = null;
      this.drag = null;
      this.paused = false;
      this.tabHidden = document.hidden;
      this.mobile = window.matchMedia('(max-width: 1023px)');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onMedia = this.onMedia.bind(this);
      this.onVisibility = this.onVisibility.bind(this);
      this.onEnter = this.onEnter.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onUnload = this.onUnload.bind(this);

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.goTo(i); this.restart(); }));
      this.mobile.addEventListener('change', this.onMedia);
      this.reduce.addEventListener('change', this.onMedia);
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('shopify:section:unload', this.onUnload);
      this.onMedia();
    }

    disconnectedCallback() { this.destroy(); }

    onUnload(event) {
      if (event.target && event.target.contains && event.target.contains(this)) this.destroy();
    }

    destroy() {
      this.stop();
      if (this.mobile) this.mobile.removeEventListener('change', this.onMedia);
      if (this.reduce) this.reduce.removeEventListener('change', this.onMedia);
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:section:unload', this.onUnload);
      this.disableCarousel();
    }

    /* Карусель — на 768 и 402; на 1920 три карточки в ряд, на 1280 колонкой */
    onMedia() {
      if (this.mobile.matches) this.enableCarousel();
      else this.disableCarousel();
    }

    enableCarousel() {
      if (this.enabled) { this.restart(); return; }
      this.enabled = true;
      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onLeave);
      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointermove', this.onPointerMove);
      this.track.addEventListener('pointerup', this.onPointerUp);
      this.track.addEventListener('pointercancel', this.onPointerUp);
      window.addEventListener('resize', this.onResize);
      this.apply(false);
      this.restart();
    }

    disableCarousel() {
      if (!this.enabled) return;
      this.enabled = false;
      this.stop();
      this.removeEventListener('focusin', this.onEnter);
      this.removeEventListener('focusout', this.onLeave);
      this.track.removeEventListener('pointerdown', this.onPointerDown);
      this.track.removeEventListener('pointermove', this.onPointerMove);
      this.track.removeEventListener('pointerup', this.onPointerUp);
      this.track.removeEventListener('pointercancel', this.onPointerUp);
      window.removeEventListener('resize', this.onResize);
      this.track.classList.remove('is-dragging');
      this.track.style.transform = '';
      this.index = 0;
      this.setActive(0);
    }

    /* Шаг ленты: 300 (карточка) + 16 (gap) = 316 при 402; padding-left ленты даёт 51 → карточка i стоит на 51 − 316·i */
    step() {
      if (this.cards.length < 2) return this.cards[0] ? this.cards[0].offsetWidth : 0;
      return this.cards[1].offsetLeft - this.cards[0].offsetLeft;
    }

    offsetFor(index) { return -this.step() * index; }

    apply(animate) {
      const instant = !animate || this.reduce.matches;
      if (instant) this.track.classList.add('is-dragging');
      this.track.style.transform = 'translateX(' + this.offsetFor(this.index) + 'px)';
      if (instant) {
        void this.track.offsetWidth;
        this.track.classList.remove('is-dragging');
      }
    }

    setActive(index) {
      this.dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    goTo(index, animate) {
      const n = this.cards.length;
      this.index = ((index % n) + n) % n;
      this.setActive(this.index);
      if (this.enabled) this.apply(animate !== false);
    }

    next() { this.goTo(this.index + 1); }

    /* Автосмена: пауза 3.5 с; стоит на паузе при hover/фокусе, во время свайпа и когда вкладка скрыта */
    start() {
      this.stop();
      if (!this.enabled || this.reduce.matches || this.paused || this.tabHidden || this.drag) return;
      this.timer = window.setInterval(() => this.next(), FyraSystemsCards.AUTOPLAY_MS);
    }

    stop() {
      if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
    }

    restart() { this.start(); }

    /* Пауза только на фокусе с клавиатуры — как в прототипе, под курсором лента листается */
    onEnter(event) { if (event && event.target && event.target.matches && !event.target.matches(':focus-visible')) return; this.paused = true; this.stop(); }
    onLeave() { this.paused = false; this.start(); }

    onVisibility() {
      this.tabHidden = document.hidden;
      if (this.tabHidden) this.stop();
      else this.start();
    }

    onResize() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => { this.raf = null; if (this.enabled) this.apply(false); });
    }

    /* Свайп: pointer events; порог 40 px, снап по центру карточки за 500 мс ease-in-out */
    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this.stop();
      this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, locked: false };
      this.dragBase = this.offsetFor(this.index);
    }

    onPointerMove(event) {
      if (!this.drag || event.pointerId !== this.drag.id) return;
      const dx = event.clientX - this.drag.x;
      const dy = event.clientY - this.drag.y;
      if (!this.drag.locked) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
        this.drag.locked = true;
        this.track.classList.add('is-dragging');
        if (this.track.setPointerCapture) this.track.setPointerCapture(event.pointerId);
      }
      let offset = this.dragBase + dx;
      const min = this.offsetFor(this.cards.length - 1);
      if (offset > 0) offset = offset * 0.3;
      if (offset < min) offset = min + (offset - min) * 0.3;
      this.drag.dx = dx;
      this.track.style.transform = 'translateX(' + offset + 'px)';
    }

    onPointerUp(event) {
      if (!this.drag || event.pointerId !== this.drag.id) return;
      const dx = this.drag.dx;
      const locked = this.drag.locked;
      this.drag = null;
      if (this.track.hasPointerCapture && this.track.hasPointerCapture(event.pointerId)) {
        this.track.releasePointerCapture(event.pointerId);
      }
      this.track.classList.remove('is-dragging');
      if (event.pointerType !== 'mouse') this.paused = false;
      if (locked) {
        let target = this.index;
        if (dx <= -FyraSystemsCards.SWIPE_THRESHOLD) target = Math.min(this.index + 1, this.cards.length - 1);
        else if (dx >= FyraSystemsCards.SWIPE_THRESHOLD) target = Math.max(this.index - 1, 0);
        this.goTo(target);
      }
      this.start();
    }
  }

  if (!customElements.get('fyra-systems-cards')) {
    customElements.define('fyra-systems-cards', FyraSystemsCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
